import React from 'react';
import { BarcodeOutlined } from '@ant-design/icons';
import { Trash2 } from 'lucide-react';
import { Form } from 'antd';
import * as S from './styles';

type ProductCardProps = {
    barcode: string;
    category: string;
    name: string;
    image_url: string;
};

export const ProductCard = ({
    image_url,
    name,
    barcode,
    category,
}: ProductCardProps) => {
    const form = Form.useFormInstance();

    const isEditing = Form.useWatch('isEditing', form);

    const qntPlanogram = Form.useWatch('planogramQnt', form);

    const handleRemoveProduct = () => {
        form.setFieldValue(['planogram', 'product_id'], null);
    };

    return (
        <S.ProductArea>
            <S.ProductFigureArea>
                <S.ImageWrapper>
                    <img
                        src={image_url}
                        alt={name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                        }}
                    />
                </S.ImageWrapper>
            </S.ProductFigureArea>

            <S.ProductInfoArea>
                <S.ProductTitle>{name}</S.ProductTitle>

                <S.ProductInfo>
                    <S.BarCodeArea>
                        <BarcodeOutlined
                            style={{
                                marginRight: 8,
                                color: '#B0B0B0',
                            }}
                        />
                        <span>
                            {barcode || 'Nenhum código de barras cadastrado'}
                        </span>
                    </S.BarCodeArea>

                    <S.CategoryProduct>
                        <span>{category ?? 'Categoria não definida'}</span>
                    </S.CategoryProduct>

                    <S.PlanogramContainer>
                        <S.PlanogramTitle>
                            Presente em {qntPlanogram} planogramas/ lojas
                        </S.PlanogramTitle>
                    </S.PlanogramContainer>
                </S.ProductInfo>
            </S.ProductInfoArea>

            {!isEditing && (
                <S.RemoveProductButton onClick={handleRemoveProduct}>
                    <Trash2 size={20} strokeWidth={2} color="#31374A" />
                </S.RemoveProductButton>
            )}
        </S.ProductArea>
    );
};
